import * as yup from 'yup'

export class SettingsVehicleReleaseDateInformationDto {
  vehicleReleaseNumberOfDaysAfterConformitySubmittedDOT?: number = undefined
}

export const vehicleReleaseDateInformationValidationSchema = yup.object<SettingsVehicleReleaseDateInformationDto>({
  vehicleReleaseNumberOfDaysAfterConformitySubmittedDOT: yup
    .number()
    .min(0, 'Vehicle Release Date Information cannot be less then 0 days.')
    .max(999_999_999_999_999, 'Vehicle Release Date Information cannot be more than 999,999,999,999,999 days.')
    .required('Vehicle Release Date Information is required.')
})
